@import (reference) '../../../../../constants/spacing.module.less';

.expanded-icon {
  width: 8px;
  margin-right: @space-8;
  cursor: pointer;
}

.product-cell {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.product-cell-no-bundle {
  margin-left: @space-16;
}

.product-img {
  box-sizing: content-box;
  padding-right: @space-8;
  width: 50px;
}

.product-info {
  flex: 1;
}

.product-name {
  display: block;
  color: var(--blue-600);
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
}

.product-sku {
  display: block;
  color: var(--grey-600);
  font-size: 12px;
  line-height: 16px;
}
